/**
 * Complete the Look — Dawn cart-drawer carousel
 *
 * Add to layout/theme.liquid before </body> (once), after base theme scripts:
 *
 * <script src="{{ 'complete-the-look-ctl.js' | asset_url }}" defer></script>
 *
 * Depends: nothing permanent — loads jQuery + Slick CDN if absent.
 *
 * Scripts inside cart-drawer section HTML DO NOT RUN when Shopify/Dawn swaps
 * innerHTML on cart refresh; this file must live in assets and load globally.
 */
(function () {
  var ROOT_ID = 'complete-the-look-root';
  var NS = (window.__COMPLETE_THE_LOOK__ = window.__COMPLETE_THE_LOOK__ || {});

  NS._depsLoaded = NS._depsLoaded || false;

  function injectSlickCssIfMissing() {
    if (document.querySelector('link[data-ctl-slick-css]')) return;
    function loadCss(href) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.setAttribute('data-ctl-slick-css', '');
      document.head.appendChild(l);
    }
    loadCss('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css');
    loadCss('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css');
  }

  function loadJQueryAndSlick(cb) {
    if (typeof window.jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      NS._depsLoaded = true;
      cb();
      return;
    }
    if (window.__CTL_JQUERY_PENDING__) {
      window.__CTL_JQUERY_PENDING__.push(cb);
      return;
    }
    window.__CTL_JQUERY_PENDING__ = [cb];

    function flush() {
      var q = window.__CTL_JQUERY_PENDING__;
      window.__CTL_JQUERY_PENDING__ = null;
      NS._depsLoaded = true;
      if (q) {
        q.forEach(function (fn) {
          fn();
        });
      }
    }

    var jq = document.createElement('script');
    jq.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
    jq.onload = function () {
      var sk = document.createElement('script');
      sk.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
      sk.onload = flush;
      sk.onerror = flush;
      document.head.appendChild(sk);
    };
    jq.onerror = flush;
    document.head.appendChild(jq);
  }

  function ensureDeps(done) {
    injectSlickCssIfMissing();
    loadJQueryAndSlick(done);
  }

  function getRoot() {
    return document.getElementById(ROOT_ID);
  }

  function variantIdForSlide(slideEl) {
    var hidden = slideEl.querySelector('.ctl-variant-id');
    if (hidden && hidden.value) return hidden.value;
    var sel = slideEl.querySelector('.ctl-variant-select');
    return sel ? sel.value : null;
  }

  function shopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function slideCount(root) {
    var track = root.querySelector('.ctl-slick');
    if (!track) return 0;
    var n = 0;
    var ch = track.children;
    var i;
    for (i = 0; i < ch.length; i++) {
      if (ch[i].nodeType === 1 && ch[i].classList && ch[i].classList.contains('ctl-slide')) n++;
    }
    return Math.max(1, n);
  }

  function initSlick($root) {
    var $slider = $root.find('.ctl-slick');
    if (!$slider.length || typeof $slider.slick !== 'function') return;
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    var show = Math.min(2, slideCount($root[0]));
    $slider.slick({
      slidesToShow: show,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      responsive: [{ breakpoint: 750, settings: { slidesToShow: Math.min(show, 2), slidesToScroll: 1 } }]
    });
  }

  NS.refreshCartDrawerAndOpen =
    NS.refreshCartDrawerAndOpen ||
    function refreshCartDrawerAndOpen(htmlString) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlString, 'text/html');
      var newDrawer = doc.querySelector('cart-drawer');
      if (!newDrawer) {
        var wrap = doc.querySelector('[id^="shopify-section"]');
        if (wrap) newDrawer = wrap.querySelector('cart-drawer');
      }
      var current = document.querySelector('cart-drawer');
      if (newDrawer && current) {
        current.innerHTML = newDrawer.innerHTML;
        if (typeof current.querySelectorAll === 'function') {
          current.querySelectorAll('script').forEach(function (oldScript) {
            var s = document.createElement('script');
            for (var i = 0; i < oldScript.attributes.length; i++) {
              var a = oldScript.attributes[i];
              s.setAttribute(a.name, a.value);
            }
            s.textContent = oldScript.textContent;
            oldScript.replaceWith(s);
          });
        }
        if (typeof current.open === 'function') {
          current.open();
        } else {
          current.setAttribute('open', '');
        }
        NS.schedule();
        return;
      }
      window.location.reload();
    };

  NS.afterAddReopenDrawer =
    NS.afterAddReopenDrawer ||
    function afterAddReopenDrawer() {
      var root = getRoot();
      var url = root ? root.getAttribute('data-sections-url') : null;
      var sectionKey = root ? root.getAttribute('data-section-key') : 'cart-drawer';
      if (!url) {
        url = shopifyRoot() + (shopifyRoot().indexOf('?') >= 0 ? '&' : '?') + 'sections=cart-drawer';
      }
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          var html = sections[sectionKey];
          if (!html || typeof html !== 'string') {
            throw new Error('missing section');
          }
          NS.refreshCartDrawerAndOpen(html);
        })
        .catch(function () {
          window.location.reload();
        });
    };

  function bindCompleteTheLook($root) {
    $root.off('click.ctl').on('click.ctl', '.ctl-add', function () {
      var $btn = $(this);
      var $slide = $btn.closest('.ctl-slide');
      var vid = variantIdForSlide($slide[0]);
      if (!vid) return;
      $btn.prop('disabled', true);
      fetch(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          NS.afterAddReopenDrawer();
        })
        .catch(function () {
          $btn.prop('disabled', false);
        });
    });

    $root.off('change.ctl').on('change.ctl', '.ctl-variant-select', function () {
      var $sel = $(this);
      $sel.closest('.ctl-slide').find('.ctl-variant-id').remove();
    });
  }

  NS.initCarousel = function () {
    NS.observeCartDrawer();
    ensureDeps(function () {
      var root = getRoot();
      if (!root) return;
      if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.slick !== 'function') {
        clearTimeout(NS._waitSlick);
        NS._waitSlick = setTimeout(NS.initCarousel, 80);
        return;
      }
      NS.pauseDrawerWatch();
      var $root = jQuery(root);
      initSlick($root);
      bindCompleteTheLook($root);
      NS.pauseDrawerWatchSoon();
    });
  };

  NS.schedule = function () {
    clearTimeout(NS._debounce);
    NS._debounce = setTimeout(function () {
      NS.observeCartDrawer();
      NS.initCarousel();
    }, 120);
  };

  function mutationTouchesCompleteTheLook(mutation) {
    if (mutation.type !== 'childList') return false;
    var k;
    var nodes = mutation.addedNodes;
    for (k = 0; k < nodes.length; k++) {
      var n = nodes[k];
      if (n.nodeType !== 1) continue;
      if (n.id === 'complete-the-look-root' || (n.classList && n.classList.contains('complete-the-look'))) return true;
      if (typeof n.querySelector === 'function' && n.querySelector('#complete-the-look-root, .complete-the-look')) return true;
    }
    nodes = mutation.removedNodes;
    for (k = 0; k < nodes.length; k++) {
      var r = nodes[k];
      if (r.nodeType !== 1) continue;
      if (r.id === 'complete-the-look-root' || (r.classList && r.classList.contains('complete-the-look'))) return true;
      if (typeof r.querySelector === 'function' && r.querySelector('#complete-the-look-root, .complete-the-look')) return true;
    }
    return false;
  }

  /** Re-init Slick when Dawn replaces cart-drawer markup. Debounced; ignores Slick-only DOM during init. */
  NS.observeCartDrawer = function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (NS._cartDrawerWatcher && NS._watchedDrawerNode === drawer) return;
    if (NS._cartDrawerWatcher) {
      NS._cartDrawerWatcher.disconnect();
      NS._cartDrawerWatcher = null;
    }
    NS._watchedDrawerNode = drawer;
    NS._cartDrawerWatcher = new MutationObserver(function (mutations) {
      if (NS._drawerMutationsIgnored) return;
      var i;
      var hit = false;
      for (i = 0; i < mutations.length; i++) {
        if (mutationTouchesCompleteTheLook(mutations[i])) {
          hit = true;
          break;
        }
      }
      if (!hit) {
        var rootNow = drawer.querySelector('#complete-the-look-root');
        if (!rootNow) return;
        var track = drawer.querySelector('.ctl-slick');
        if (
          track &&
          track.querySelector('.ctl-slide') &&
          !track.classList.contains('slick-initialized')
        ) {
          hit = true;
        }
      }
      if (!hit) return;
      clearTimeout(NS._drawerMutDebounce);
      NS._drawerMutDebounce = setTimeout(NS.schedule, 220);
    });
    NS._cartDrawerWatcher.observe(drawer, { childList: true, subtree: true });
  };

  NS.pauseDrawerWatch = function () {
    NS._drawerMutationsIgnored = true;
    clearTimeout(NS._resumeDrawerWatchTimer);
  };

  NS.pauseDrawerWatchSoon = function () {
    clearTimeout(NS._resumeDrawerWatchTimer);
    NS._resumeDrawerWatchTimer = setTimeout(function () {
      NS._drawerMutationsIgnored = false;
    }, 550);
  };

  if (!NS.__listenersAttached) {
    NS.__listenersAttached = true;
    [
      'cart:updated',
      'cart:change',
      'cart-drawer:updated',
      'cart-drawer:refresh',
      'cart:refresh',
      'shopify:section:cart-drawer'
    ].forEach(function (name) {
      document.documentElement.addEventListener(name, NS.schedule, true);
    });
  }

  function boot() {
    NS.observeCartDrawer();
    NS.schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onDomReady() {
      document.removeEventListener('DOMContentLoaded', onDomReady);
      boot();
    });
  } else {
    boot();
  }
})();
